import { isApiError } from '@counsel-project/client-utils'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import Cookies from 'js-cookie'
import { useCallback, useEffect } from 'react'
import usePageTitle from '../util/usePageTitle'
import { toast } from 'react-hot-toast'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { loginWithMicrosoft } from '../util/auth/login'
import { MS_REDIRECT_URI } from '../components/auth/util'
import useUser from '../util/auth/useUser'
import log from '../util/logging'
import { acceptPrivacyPolicy } from '../util/privacy-policy'
import { setStore } from '../util/store/auth'
import { logLogin } from '../util/tracking'
import { attemptJSONParse } from './login'

const MSLoginPage = () => {
  usePageTitle('Microsoft Login')
  const [searchParams] = useSearchParams()
  const state = searchParams.get('state')
  let page = attemptJSONParse(decodeURIComponent(state ?? ''))?.page
  if (page === '/login' || page === '/register') {
    page = undefined
  }
  const [user] = useUser()
  const navigate = useNavigate()

  const handleMicrosoftLogin = useCallback(async () => {
    try {
      const code = searchParams.get('code')
      if (!code) {
        toast.error('Authentication code not found')
        navigate('/login')
        return
      }

      setStore({
        user: null,
      })

      Cookies.remove('expiresAt')

      logLogin('microsoft')

      await loginWithMicrosoft({
        code,
        redirectUri: MS_REDIRECT_URI,
      })

      acceptPrivacyPolicy()
    } catch (err) {
      if (isApiError(err)) {
        log.error(err.message)
        toast.error(err.msg)
      } else {
        toast.error('Error logging in with Microsoft')
        log.error(err)
      }

      navigate('/login')
    }
  }, [navigate, searchParams])

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleMicrosoftLogin().catch(log.error)
    }, 100)
    return () => clearTimeout(timeout)
  }, [handleMicrosoftLogin])

  const handleAfterLogin = useCallback(() => {
    if (!user) return
    navigate(page ?? '/')
  }, [user, navigate, page])

  useEffect(() => {
    handleAfterLogin()
  }, [handleAfterLogin])

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
      <CircularProgress />
    </Grid>
  )
}

export default MSLoginPage
